import React from 'react'

import RequestReferralCallbackForm, {
  RequestCallbackFormValues,
} from '@/components/misc/RequestReferralCallbackForm'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface Props {
  company: React.ComponentProps<typeof RequestReferralCallbackForm>['company']
  onSubmit: (values: RequestCallbackFormValues) => void
  callbackTelephone?: string
  onHide: () => void
}

const RequestCallbackModal: React.FC<Props> = ({
  company,
  callbackTelephone,
  onSubmit,
  onHide,
}) => {
  if (callbackTelephone) {
    return (
      <Dialog open onHide={onHide}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Callback submitted!</DialogTitle>
          </DialogHeader>

          <DialogBody>
            <p className="mb-4">
              Your callback preferences have been submitted to{' '}
              {company.presentationName}.
            </p>

            <p className="mb-0">
              The adviser will call you on {callbackTelephone}.
            </p>
          </DialogBody>

          <DialogFooter>
            <Button variant="outline-secondary" onClick={onHide}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    )
  }

  return (
    <Dialog open onHide={onHide}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Schedule a meeting</DialogTitle>
        </DialogHeader>

        <DialogBody>
          <RequestReferralCallbackForm
            company={company}
            onSubmit={(values) => {
              onSubmit(values)
            }}
          />
        </DialogBody>
      </DialogContent>
    </Dialog>
  )
}

export default RequestCallbackModal
